import { FormType } from '@lenderful/domain';
import { Type } from 'app/actions/form/types';
import { RootState } from 'app/store/types';

type SubmittedDataState = {
  [K in FormType]: any;
}

const initialState: SubmittedDataState = {
  [FormType.AGRICULTURAL]: null,
  [FormType.AGRICULTURAL_LINE_OF_CREDIT]: null,
  [FormType.AGRICULTURAL_PURCHASE_ACREAGE]: null,
  [FormType.AGRICULTURAL_PURCHASE_EQUIPMENT]: null,
  [FormType.AGRICULTURAL_REFINANCE_PROPERTY]: null,
  [FormType.AUTO_PREQUAL]: null,
  [FormType.CONSTRUCTION]: null,
  [FormType.CONTACT]: null,
  [FormType.CREDIT_BOOSTER]: null,
  [FormType.CREDIT_CARD]: null,
  [FormType.FINANCIAL_STATEMENT]: null,
  [FormType.HOME_EQUITY]: null,
  [FormType.HOME_EQUITY_TURBO_WELCOME]: null,
  [FormType.HOME_EQUITY_INQUIRY]: null,
  [FormType.HOME_EQUITY_RATES]: null,
  [FormType.HOME_EQUITY_LONG_FORM]: null,
  [FormType.LAND]: null,
  [FormType.LOAN_OFFICER]: null,
  [FormType.LONG_FORM]: null,
  [FormType.SHORT_FORM_PURCHASE]: null,
  [FormType.SHORT_FORM_REFINANCE]: null,
  [FormType.OVERDRAFT_PROTECTION]: null,
  [FormType.PERSONAL]: null,
  [FormType.PERSONAL_LOAN_INQUIRY]: null,
  [FormType.COMMERCIAL]: null,
  [FormType.COMMERCIAL_BRIDGE_LOAN]: null,
  [FormType.COMMERCIAL_EQUIPMENT]: null,
  [FormType.COMMERCIAL_LEASE_EQUIPMENT]: null,
  [FormType.COMMERCIAL_LEASE_MUNICIPAL]: null,
  [FormType.COMMERCIAL_PURCHASE]: null,
  [FormType.COMMERCIAL_REFINANCE]: null,
  [FormType.COMMERCIAL_RENEW]: null,
  [FormType.COMMERCIAL_VEHICLE]: null,
  [FormType.CLOSING_COSTS]: null,
  [FormType.AUTO]: null,
  [FormType.AUTO_BASIC]: null,
  [FormType.AUTO_LOAN_INQUIRY]: null,
  [FormType.HOME_EQUITY_TURBO]: null,
  [FormType.OTHER_VEHICLE]: null,
  [FormType.OTHER_VEHICLE_BASIC]: null,
  [FormType.OTHER_VEHICLE_INQUIRY]: null,
  [FormType.PURCHASE_TURBO]: null,
  [FormType.REFINANCE_TURBO]: null,
  [FormType.REVERSE]: null,
  [FormType.INSURANCE_QUOTE]: null,
  [FormType.SMALL_BUSINESS_LINE_OF_CREDIT]: null,
  [FormType.SMALL_BUSINESS_TERM]: null,
  [FormType.DOCUMENT_UPLOADER]: null,
};

export const submittedDataReducer = (state = initialState, action): SubmittedDataState => {
  switch (action.type) {
    case Type.SET_SUBMITTED_DATA:
      return {
        ...state,
        [action.formName]: action.payload,
      };

    default:
      return state;
  }
};

export const getSubmittedData = (state: RootState): SubmittedDataState => {
  return state.submittedData;
};

